import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import ApiService from "../../helpers/Services";

const FileDropZone = ({ value, onChange, accept, fieldName }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const onDrop = useCallback(async (files) => {
    if (!files.length) return;
    const file = files[0];
    setError("");
    setUploading(true);
    try {
      const data = await ApiService.post("create-signed-url", {
        mode: "smc-scratch",
        filename: file.name,
        contentType: file.type || "application/octet-stream",
      });
      if (!data?.signedURL) throw new Error("missing signedURL in response");
      await axios.put(data.signedURL, file, {
        headers: { "Content-Type": file.type || "application/octet-stream" },
      });
      onChange({ url: data.publicURL || data.location, filename: file.name, size: file.size });
    } catch (e) {
      console.error(e);
      setError(e?.message || "upload failed");
    } finally {
      setUploading(false);
    }
  }, [onChange]);

  const acceptMap = accept
    ? accept.split(",").reduce((m, t) => ({ ...m, [t.trim()]: [] }), {})
    : undefined;

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: acceptMap,
    multiple: false,
  });

  if (value?.url) {
    return (
      <div className="smc-dropzone has-file">
        📎 <strong>{value.filename}</strong>
        {value.size ? ` (${(value.size / 1024).toFixed(1)} KB)` : ""}
        <button
          type="button"
          className="smc-dropzone-clear"
          onClick={() => onChange(null)}
          aria-label={`Remove ${fieldName}`}
        >
          Remove
        </button>
        {error && <div className="smc-field-error">{error}</div>}
      </div>
    );
  }

  return (
    <div {...getRootProps()} className={`smc-dropzone ${isDragActive ? "is-active" : ""}`}>
      <input {...getInputProps()} />
      {uploading
        ? "Uploading…"
        : isDragActive
          ? "Drop the file here"
          : "Drop a file here, or click to browse"}
      {accept && <div className="smc-field-help" style={{ marginTop: 6 }}>Accepted: {accept}</div>}
      {error && <div className="smc-field-error">{error}</div>}
    </div>
  );
};

export default FileDropZone;
